<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>

        <el-table-column prop="DepartmentName" label="所属部门" min-width="120" show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="Name" label="菜品名称" min-width="140" show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="CategoryName" label="所属分类" width="110" show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="Price" label="价格" width="90" align="right" header-align="right">
        </el-table-column>

        <!-- <el-table-column prop="DailyTotal" label="每天总数" width="">
        </el-table-column> -->

        <!-- <el-table-column prop="TimeSlotNames" label="可售时间段" width="">
          <template slot-scope="scope">
            <div v-if="scope.row.TimeSlotNames && scope.row.TimeSlotNames.length > 0">
              {{ scope.row.TimeSlotNames.join(', ') }}
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column> -->

        <el-table-column prop="Description" label="菜品描述" min-width="180" show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="MediaFiles" label="菜品图片" width="140" align="center" header-align="center">
          <template slot-scope="scope">
            <oss-media-thumbs :media="scope.row.MediaFiles" :max="2" />
          </template>
        </el-table-column>

        <el-table-column prop="CreateTime" label="添加时间" width="160">
        </el-table-column>

      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="PageSize" :total="total" style="float: right"></el-pagination>
      </el-col>

      <!--编辑界面-->
      <el-dialog title="编辑菜品" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false"
        destroy-on-close @close="handleEditDialogClose">
        <el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">
          <el-form-item label="菜品名称" prop="Name">
            <el-input v-model="editForm.Name" auto-complete="off"></el-input>
          </el-form-item>

          <!-- 去除所属部门选择，直接关联页面统一选中的学校 ID -->

          <el-form-item label="所属分类" prop="CategoryId">
            <el-select v-model="editForm.CategoryId" placeholder="请选择菜品分类" style="width: 100%">
              <el-option v-for="item in categoryList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="可售时间段" prop="TimeSlotIds">
            <el-select v-model="editForm.TimeSlotIds" placeholder="请选择可售时间段" multiple style="width: 100%">
              <el-option v-for="item in timeSlotList" :key="item.Id"
                :label="`${item.DinnerName} (${item.StartTime} - ${item.EndTime})`" :value="item.Id"></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="价格" prop="Price">
            <el-input v-model.number="editForm.Price" type="number" step="0.01" min="0" placeholder="请输入价格"></el-input>
          </el-form-item>

          <!-- <el-form-item label="每天总数" prop="DailyTotal">
            <el-input v-model.number="editForm.DailyTotal" type="number" min="1" placeholder="请输入每天总数"></el-input>
          </el-form-item> -->

          <el-form-item label="菜品图片">
            <el-upload class="upload-demo" action="#" :auto-upload="false"
              list-type="picture-card" :file-list="EditUploadFiles"
              :on-change="(file, fileList) => deferredPictureCardChange(file, fileList, 'EditUploadFiles')"
              :on-remove="(file, fileList) => deferredPictureCardRemove(file, fileList, 'EditUploadFiles')"
              :multiple="false" :limit="9" :on-exceed="handleMediaExceed"
              accept=".png,.jpg,.jpeg,.gif,.bmp,.webp">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="菜品描述" prop="Description">
            <el-input v-model="editForm.Description" type="textarea" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增菜品" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm" class="demo-form-inline">
          <el-form-item label="菜品名称" prop="Name">
            <el-input v-model="addForm.Name" auto-complete="off"></el-input>
          </el-form-item>

          <!-- 去除所属部门选择，直接关联页面统一选中的学校 ID -->

          <el-form-item label="所属分类" prop="CategoryId">
            <el-select v-model="addForm.CategoryId" placeholder="请选择菜品分类" style="width: 100%">
              <el-option v-for="item in categoryList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="可售时间段" prop="TimeSlotIds">
            <el-select v-model="addForm.TimeSlotIds" placeholder="请选择可售时间段" multiple style="width: 100%">
              <el-option v-for="item in timeSlotList" :key="item.Id"
                :label="`${item.DinnerName} (${item.StartTime} - ${item.EndTime})`" :value="item.Id"></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="价格" prop="Price">
            <el-input v-model.number="addForm.Price" type="number" step="0.01" min="0" placeholder="请输入价格"></el-input>
          </el-form-item>

          <!-- <el-form-item label="每天总数" prop="DailyTotal">
            <el-input v-model.number="addForm.DailyTotal" type="number" min="1" placeholder="请输入每天总数"></el-input>
          </el-form-item> -->

          <el-form-item label="菜品图片">
            <el-upload class="upload-demo" action="#" :auto-upload="false"
              list-type="picture-card" :file-list="UploadFiles"
              :on-change="(file, fileList) => deferredPictureCardChange(file, fileList, 'UploadFiles')"
              :on-remove="(file, fileList) => deferredPictureCardRemove(file, fileList, 'UploadFiles')"
              :multiple="false" :limit="9" :on-exceed="handleMediaExceed"
              accept=".png,.jpg,.jpeg,.gif,.bmp,.webp">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="菜品描述" prop="Description">
            <el-input v-model="addForm.Description" type="textarea" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getDishListPage, editDish, addDish, deleteDish, getDishCategoryListPage } from '../../api/modules/catering';
import { BaseApiUrl } from '../../api/base';
import { getDinnerTimeList } from '../../api/modules/consumption';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import es from "@/lang/es";

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '名称',
          key: 'name',
        },
      ],
      users: [],
      roles: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      PageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [{ required: true, message: "请输入菜品名称", trigger: "blur" }],
        CategoryId: [{ required: true, message: "请选择所属分类", trigger: "change" }],
        Price: [
          { required: true, message: "请输入价格", trigger: "blur" },
          { type: 'number', message: "请输入有效的数字", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value <= 0) {
                callback(new Error('价格必须大于 0'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],

        // DailyTotal: [
        //   { required: true, message: "请输入每天总数", trigger: "blur" },
        //   { type: 'number', message: "请输入有效的数字", trigger: "blur" },
        //   {
        //     validator: (rule, value, callback) => {
        //       if (value <= 0) {
        //         callback(new Error('每天总数必须大于 0'));
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: 'blur'
        //   }
        // ],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        Name: '',
        CategoryId: '',
        Price: 0,
        ImageUrls: '',
        TimeSlotIds: '',
        Description: '',
        DepartmentId: 0,
        DailyTotal: 1,
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入菜品名称", trigger: "blur" }],
        CategoryId: [{ required: true, message: "请选择所属分类", trigger: "change" }],
        Price: [
          { required: true, message: "请输入价格", trigger: "blur" },
          { type: 'number', message: "请输入有效的数字", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value <= 0) {
                callback(new Error('价格必须大于 0'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        // DailyTotal: [
        //   { required: true, message: "请输入每天总数", trigger: "blur" },
        //   { type: 'number', message: "请输入有效的数字", trigger: "blur" },
        //   {
        //     validator: (rule, value, callback) => {
        //       if (value <= 0) {
        //         callback(new Error('每天总数必须大于 0'));
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: 'blur'
        //   }
        // ],
      },
      //新增界面数据
      addForm: {
        Name: '',
        CategoryId: '',
        Price: 0,
        ImageUrls: '',
        TimeSlotIds: '',
        Description: '',
        DepartmentId: 0,
        DailyTotal: 1,
      },

      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,
      categoryList: [], //菜品分类列表
      timeSlotList: [], // 就餐时间段列表
      UploadFiles: [],     // 新增用
      EditUploadFiles: [], // 编辑用
    };
  },
  methods: {

    handleEditDialogClose() {
      this.deferredPictureCardClear('EditUploadFiles');
    },
    handleMediaExceed(files, fileList) {
      this.$message.warning('最多上传9张图片');
    },

    // 获取就餐时间段列表
    getDinnerTimeListData(id) {
      let para = {
        departmentId: id
      }
      getDinnerTimeList(para).then(res => {
        if (res.data && res.data.response) {
          this.timeSlotList = res.data.response;
        }
      });
      this.getCategoryList(id);
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery()
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    // 获取菜品分类列表
    getCategoryList(id) {
      let para = {
        departmentId: id,
        page: 1,
        intPageSize: 500,
      }
      getDishCategoryListPage(para).then(res => {
        if (res.data && res.data.response) {
          this.categoryList = res.data.response.data || [];
        }
      });
    },

    //获取用户列表
    handleQuery() {
      let para = {
        departmentId: this.DepartmentId,
        ...this.filters,
        page: this.page,
      }
      this.listLoading = true;
      testapi();
      getDishListPage(para).then(async (res) => {
        this.total = res.data.response.dataCount
        this.PageSize = res.data.response.PageSize
        const rows = res.data.response.data || []
        await this.prefetchListOssMedia(rows, 'MediaFiles')
        this.users = rows
        this.listLoading = false
      });
    },
    //显示编辑界面
    async handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editForm = Object.assign({}, row);
      this.editForm.DepartmentId = row.DepartmentId || this.DepartmentId;
      this.getDinnerTimeListData(this.editForm.DepartmentId);

      this.EditUploadFiles = await this.deferredPictureCardFromMedia(this.editForm.MediaFiles)

      // 将TimeSlotIds字符串转换为数组
      if (this.editForm.TimeSlotIds && typeof this.editForm.TimeSlotIds === 'string') {
        this.editForm.TimeSlotIds = this.editForm.TimeSlotIds.split(',').map(id => id);
      } else if (!Array.isArray(this.editForm.TimeSlotIds)) {
        this.editForm.TimeSlotIds = [];
      }

      this.editFormVisible = true;
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(async () => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            const mediaUrls = await this.deferredPictureCardEnsure(this.EditUploadFiles, 'Dish');
            para.MediaFiles = mediaUrls.join(';');
            // 将TimeSlotIds数组转换为字符串
            if (para.TimeSlotIds && para.TimeSlotIds.length > 0) {
              para.TimeSlotIds = para.TimeSlotIds.join(',');
            } else {
              para.TimeSlotIds = '';
            }

            editDish(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
                this.editLoading = false;
              }
            });
          });
        }
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          deleteDish(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示新增界面
    handleAdd() {
      if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
        this.$message.warning('请先在左侧选择具体的学校机构！');
        return;
      }
      this.addFormVisible = true;
      this.deferredPictureCardClear('UploadFiles');
      this.addForm = {
        Name: '',
        CategoryId: '',
        Price: 0,
        ImageUrls: '',
        TimeSlotIds: '',
        Description: '',
        DepartmentId: this.DepartmentId,
        DailyTotal: 1,
      };
      this.getDinnerTimeListData(this.DepartmentId);
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(async () => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            const mediaUrls = await this.deferredPictureCardEnsure(this.UploadFiles, 'Dish');
            para.MediaFiles = mediaUrls.join(';');
            // 将TimeSlotIds数组转换为字符串
            if (para.TimeSlotIds && para.TimeSlotIds.length > 0) {
              para.TimeSlotIds = para.TimeSlotIds.join(',');
            } else {
              para.TimeSlotIds = '';
            }

            addDish(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}
</style>
